import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { cn } from '@/lib/utils';

interface BackLinkProps {
  /** Route to navigate back to (e.g. `/vendors/:id`). */
  to: string;
  /** Human label for the destination — renders as "Back to {label}". */
  label: string;
  className?: string;
}

/**
 * Shared contextual back-link used on detail pages to return to a parent entity
 * (e.g. "← Back to {vendor name}"). Consistent icon (ArrowLeft) + styling so nav
 * reads the same across surfaces. Unlike the global path-driven Breadcrumbs, this
 * takes an explicit route + dynamic label, so it can render an entity name.
 */
export function BackLink({ to, label, className }: BackLinkProps) {
  return (
    <Link
      to={to}
      className={cn(
        'inline-flex items-center gap-1.5 text-sm text-text-secondary hover:text-text-primary transition-colors',
        className,
      )}
    >
      <ArrowLeft className="h-4 w-4" />
      Back to {label}
    </Link>
  );
}
